import { INotificationState } from '../../types/notification';
import { IAction } from '../../types/generics';
import { CLOSE_NOTIFICATIONS_WITH_IDS_FAIL, CLOSE_NOTIFICATIONS_WITH_IDS_SUCCESS, GET_NOTIFICATIONS_FAIL, GET_NOTIFICATIONS_SUCCESS, SET_LOADING, UPDATE_NOTIFICATION_STATE_FAIL, UPDATE_NOTIFICATION_STATE_SUCCESS } from '../../types';


const initialState: INotificationState = {
  notifications: [],
  notification: null,
  success: true,
  loading: false,
  error: '',
};

const notificationReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload,
        status: true,
        error: '',
      };
    case GET_NOTIFICATIONS_FAIL:
      return {
        ...state,
        status: false,
        error: action.payload,
      };
    case UPDATE_NOTIFICATION_STATE_SUCCESS:
      return {
        ...state,
        notification: action.payload,
        status: true,
        error: '',
      };
    case UPDATE_NOTIFICATION_STATE_FAIL:
      return {
        ...state,
        status: false,
        error: action.payload,
      };
    case CLOSE_NOTIFICATIONS_WITH_IDS_SUCCESS:
      return {
        ...state,
        status: true,
        notifications: [],
      };
    case CLOSE_NOTIFICATIONS_WITH_IDS_FAIL:
      return {
        ...state,
        status: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default notificationReducer;
